export default __webpack_public_path__ + "static/media/coupon-fill.e4cfe1b6.svg";